var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"employer-desc-root-container"},[_c('img',{staticClass:"employer-desc-edit",attrs:{"src":_vm.icons.edit},on:{"click":_vm.edit}}),_c('span',{staticClass:"employer-desc-title"},[_vm._v("雇主品牌描述")]),_c('p',[_vm._v(_vm._s(_vm.desc))]),_c('employer-desc-drawer',{ref:"employerDescDrawer",on:{"refresh-desc":_vm.refreshDesc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }